import { Checkbox, Flex, Form, Input } from "antd";

export default function RenderCheckbox(props) {
	const { namePath = [], form_question_options = [], required = false } = props;
	let newNamePath = Array.isArray(namePath) ? namePath.join("_") : namePath;

	return (
		<Form.Item shouldUpdate noStyle>
			{({ getFieldValue }) => {
				let selectedValue = getFieldValue(newNamePath);
				let findOther = form_question_options.find((x) => x.is_other)?.option;

				return (
					<Form.Item
						name={newNamePath}
						rules={[
							{
								required: required ? true : false,
								message: "Please select at least one option",
							},
						]}
					>
						<Checkbox.Group>
							<Flex align="baseline" gap={5} vertical>
								{form_question_options.map((option, index) => (
									<Checkbox key={`${option.id}-${index}`} value={option.option}>
										<Flex align="center" gap={5}>
											{option.option}
											{option.is_other &&
											selectedValue &&
											selectedValue.includes(findOther) ? (
												<Form.Item name={`${newNamePath}_other`} noStyle>
													<Input placeholder="Please specify" />
												</Form.Item>
											) : null}
										</Flex>
									</Checkbox>
								))}
							</Flex>
						</Checkbox.Group>
					</Form.Item>
				);
			}}
		</Form.Item>
	);
}
